( function( $, document, window ) {
    'use strict';

    $( function() {
        $( document ).on( 'click', '.js-trigger-next', function( event ) {
        	event.preventDefault();

	        $( this ).closest( '.gform_page' ).find( '.gform_next_button' ).trigger( 'click' );
        } );
    } );
} )( jQuery, document, window );
